var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkIndicatorNoneMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.99183,
    y: 0.328984,
    width: 23.342,
    height: 23.342,
    rx: 11.671,
    fill: "#FBEAEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99183,
    y: 0.328984,
    width: 23.342,
    height: 23.342,
    rx: 11.671,
    stroke: "#991F27",
    strokeWidth: 0.657968
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11141_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03809 5.8125L19.2881 18.1875",
    stroke: "#991F27",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2256 18.1875C14.8469 18.1875 15.3506 17.6838 15.3506 17.0625C15.3506 16.4412 14.8469 15.9375 14.2256 15.9375C13.6043 15.9375 13.1006 16.4412 13.1006 17.0625C13.1006 17.6838 13.6043 18.1875 14.2256 18.1875Z",
    fill: "#991F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69746 7.64062C8.48221 8.08503 7.35069 8.73137 6.35059 9.55242",
    stroke: "#991F27",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9756 9.55244C18.9158 7.85797 16.3303 6.93342 13.6631 6.93751C13.1694 6.93733 12.6762 6.96856 12.1865 7.03103",
    stroke: "#991F27",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2414 10.4365C10.9107 10.6698 9.65932 11.2315 8.60059 12.0706",
    stroke: "#991F27",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7254 12.0702C17.7313 11.2814 16.5663 10.7365 15.3237 10.479",
    stroke: "#991F27",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5482 14.0736C14.7864 13.7476 13.9531 13.6249 13.1297 13.7175C12.3063 13.81 11.521 14.1147 10.8506 14.6016",
    stroke: "#991F27",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11141_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.66284 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIndicatorNoneMobile);
export default __webpack_public_path__ + "static/media/network_indicator_none_mobile.84d55b21a4e946a74bf71c5eff30ba89.svg";
export { ForwardRef as ReactComponent };